import { h } from "preact";
import { classNames } from "../helpers.js";

import Avatar from "./Avatar.jsx";
import UserPositionAndCountry from "./UserPositionAndCountry.jsx";
import CompanyAndCountry from "./CompanyAndCountry.jsx";
import CompanyLogo from "./CompanyLogo.jsx";
import RedactedInfo from "./RedactedInfo.jsx";

export default function AvatarAndUserInfo({
  bordered,
  user,
  namePostfix,
  company,
  previewMode,
  ...props
}) {
  return (
    <div
      class={classNames(
        "avatar-and-user-info",
        bordered && "avatar-and-user-info--bordered",
        props.class
      )}
    >
      <div class="avatar-and-user-info__avatar">
        {company ? (
          <CompanyLogo noHover big company={company} />
        ) : (
          <Avatar
            grey={previewMode}
            noHover
            user={previewMode ? null : user}
            plain
            big
          />
        )}
      </div>
      <div class="avatar-and-user-info__content">
        <div
          class="t-h5 t-h5--margin-small avatar-and-user-info__content__name"
          data-testid="username"
        >
          {previewMode ? <RedactedInfo large w256 /> : user.name}
          {namePostfix}
        </div>

        {company ? (
          <CompanyAndCountry
            smaller
            company={company}
            user={user}
            previewMode={previewMode}
          />
        ) : (
          <UserPositionAndCountry
            smaller
            user={user}
            previewMode={previewMode}
          />
        )}
      </div>
    </div>
  );
}
